import React from "react";
import DeleteModal from "../../Modal/DeleteModal";

export function ReportAbuseDeleteModal({
  isLoadingDeleteReportAbuse,
  onClickOfSaveButton,
  handleDeleteHide,
  isDeleteModal,
}) {
  return (
    <>
      <DeleteModal
        isLoading={isLoadingDeleteReportAbuse}
        handleDeleteHide={handleDeleteHide}
        isDeleteModal={isDeleteModal}
        title={"Record Delete"}
        message={"Are you sure to permanently delete this Record?"}
        onClickOfSaveButton={onClickOfSaveButton}
        onClickOfCancelButton={handleDeleteHide}
        saveButtonLabel={"Delete"}
        cancelButtonLabel={"Cancel"}
      />
    </>
  );
}
